import Styles from './ChallengeKnowledgeCheckTabs.module.scss';
import React, { useState, useEffect } from 'react';

// Module imports.
import {
    TextField, FormHelperText, InputLabel, Select, MenuItem, FormControl,
    Paper, Typography, Slide, Grow
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// Component import.
import { useTranslation } from 'components/lib';

export function ChallengeKnowledgeCheckTabs(props) {

    const challengeData = props.challengeData;
    const testCaseResponses = props.testCaseResponses;
    const { t } = useTranslation();

    // checks if the given test case is covered
    const [uncoveredTestCase, setUncoveredTestCase] = useState(true);
    const [headerIcon, setHeaderIcon] = useState(null);
    const [headerText, setHeaderText] = useState('');


    useEffect(() => {
        if (props.isResults) {
            const flag = challengeData[0].flags[props.tabIndex];
            if (flag) {
                setHeaderIcon(<CheckCircleIcon fontSize="small" sx={{ mr: '2px' }} />);
                setHeaderText(t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.header.correct'));
            } else {
                setHeaderIcon(<CancelIcon fontSize="small" sx={{ mr: '2px' }} />);
                setHeaderText(t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.header.incorrect'));
            }
        }
        setUncoveredTestCase(!testCaseResponses[props.tabIndex].includes(-1));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tabIndex]);

    const handleChange = (event) => {
        const updatedArray = [...props.testCaseAns];
        updatedArray[props.tabIndex] = event.target.value;
        props.setTestCaseAns(updatedArray);
    };

    const CustomPaper = () => (
        <Paper
            elevation={8}
            sx={{
                display: "flex",
                flexDirection: "column",
                mb: "21px",
                borderRadius: "8px",
                bgcolor: "darkslategray",
                color: "white"
            }}
        >
            <Typography sx={{ padding: "16px 8px" }}>
                <LockIcon sx={{ mr: 1 }} /> {t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.locked')}
            </Typography>
        </Paper>
    );

    return (
        <>
            <div id='testCasesContainer' className={Styles.testCasesContainer}>
                <React.Fragment key={`li-testCaseList`}>
                    {(challengeData[0].input_details).map((value, index) => (
                        <div id={`testCaseContainer${value}`} key={`${value.label}-${index}`} style={{ width: '100%' }}>
                            <br></br>
                            <TextField
                                id={`input-${index}`}
                                // key={`testcaseinput-${index}`}
                                label={value.label}
                                variant="filled"
                                style={{
                                    width: '100%'
                                }}
                                size="small"
                                value={
                                    !uncoveredTestCase
                                        ? "N/A" : testCaseResponses[props.tabIndex][index]
                                }
                                InputProps={{
                                    readOnly: true,
                                    sx: {
                                        fontWeight: 600,
                                        '&.Mui-disabled': {
                                            fontWeight: 600,
                                        },
                                    },
                                }}
                                sx={{
                                    width: "fit-content",
                                    backgroundColor: "#20212412"
                                }}

                            />
                            <FormHelperText id="component-helper-text">
                                {value.descr}
                            </FormHelperText>
                        </div>
                    ))}
                </React.Fragment>
            </div>
            <div id='selectorContainer' className={Styles.selectorContainer}>
                {
                    !props.isResults ?
                        <>
                            {
                                uncoveredTestCase ?
                                    <FormControl
                                        variant="filled" sx={{ minWidth: 300 }}
                                        disabled={!uncoveredTestCase}
                                        required={uncoveredTestCase}
                                    >
                                        <InputLabel id="testCaseTechLabel">
                                            {t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.form.label')}
                                        </InputLabel>
                                        <Select
                                            labelId="testCaseTechLabel"
                                            id="testCaseSelector"
                                            value={props.testCaseAns[props.tabIndex] ? props.testCaseAns[props.tabIndex] : ""}
                                            // label="Test Case Technique"
                                            onChange={handleChange}
                                            sx={{
                                                width: "100%",
                                                backgroundColor: "#fffcfcd1"
                                            }}
                                            variant='filled'
                                        >
                                            <MenuItem key={"blankValue"} value={-1}>
                                                <em>None</em>
                                            </MenuItem>
                                            {(challengeData[0].testCaseTechniques).map((value, index) => (
                                                <MenuItem key={`${value}`} value={value}>{value}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText
                                            sx={{
                                                fontWeight: 800,
                                            }}
                                        >
                                            {t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.form.helperText')}
                                        </FormHelperText>
                                    </FormControl>
                                    :
                                    <Grow in={!uncoveredTestCase} mountOnEnter unmountOnExit>
                                        <div>
                                            <CustomPaper />
                                        </div>
                                    </Grow>
                            }
                        </>
                        : <>
                            {
                                uncoveredTestCase ?
                                    <>
                                        <Slide direction="right" in mountOnEnter unmountOnExit>
                                            <div id='resultFeedbackContainer'
                                                className={Styles.resultFeedbackContainer}
                                                style={{
                                                    backgroundColor: challengeData[0].flags[props.tabIndex]
                                                        ? '#f4faf8' : '#fef4f5',
                                                    // backgroundColor: 'red'
                                                    width: "-webkit-fill-available",
                                                    margin: "16px",
                                                }}
                                            >
                                                <h3 style={{
                                                    color: challengeData[0].flags[props.tabIndex]
                                                        ? '#1a8a20' : '#dc3445',
                                                }}>
                                                    {headerIcon}{headerText}
                                                </h3>
                                                <p>
                                                    <b>
                                                        {t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.knowledgeCheckTab.uncovered')}
                                                    </b>
                                                    {`${challengeData[0].selectedAnswers[props.tabIndex]}`}
                                                </p>
                                            </div>
                                        </Slide>
                                    </>
                                    :
                                    <>
                                        <Grow in={!uncoveredTestCase} mountOnEnter unmountOnExit>
                                            <div>
                                                <CustomPaper />
                                            </div>
                                        </Grow>
                                    </>
                            }
                        </>
                }
            </div >
        </>
    );
};
